import { ExerciseSelection } from '../../entities';
import { WorkoutSettings } from '../../entities/user/workoutsettings';
import { Exercise } from './../../entities/exercise/exercise';
import { IExerciseSelectionFilter } from './workoutselectionmanager';

export class DisabledFilter implements IExerciseSelectionFilter {
    public description: string = 'Return only non disabled exercises';
    public name: string = 'DisabledFilter';
    public filter(inputExercises: Exercise[],
                  exerciseSelection: ExerciseSelection,
                  userWorkoutSettings: WorkoutSettings,
                  selectedZoneExercisesSoFar: Exercise[]): Exercise[] {
        return inputExercises.filter((e) => e.disable !== true );
    }
}
